import type { TFunction } from 'i18next';
import { DiscardModal } from '@components/ui/DiscardModal/DiscardModal';
import type { useSimilarNameGuard } from './useSimilarNameGuard';

interface ISimilarNameGuardModalProps {
  guard: ReturnType<typeof useSimilarNameGuard>;
  /** The name as typed — what Keep-as-new would mint. */
  typed: string;
  /** The already-translated body — each form words its own consequence. */
  body: string;
  t: TFunction;
}

/**
 * The save-time similar-name confirmation, shared by the stock and delivery
 * forms — one place wiring `useSimilarNameGuard` to the stacked `DiscardModal`
 * and the neutral `logistics.similarName.*` copy.
 */
export function SimilarNameGuardModal({ guard, typed, body, t }: ISimilarNameGuardModalProps) {
  return (
    <DiscardModal
      open={guard.open}
      title={t('logistics.similarName.guardTitle')}
      description={body}
      confirmLabel={t('logistics.similarName.keepNew', { name: typed })}
      altAction={{ label: t('logistics.similarName.use', { name: guard.match ?? '' }), onClick: guard.useExisting }}
      onConfirm={guard.keepNew}
      onCancel={guard.dismiss}
    />
  );
}
